import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "item", "count"]

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.itemTargets.forEach(item => item.checked = checked)
    this.updateCount()
  }

  updateCount() {
    const checked = this.itemTargets.filter(i => i.checked).length
    const total = this.itemTargets.length
    this.countTarget.textContent = checked
    this.selectAllTarget.checked = checked === total
    this.selectAllTarget.indeterminate = checked > 0 && checked < total
  }
}
